module.exports = __webpack_public_path__ + "static/media/pause.2e6b892b.svg";